 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"CycleOdds~CycleProfit~Dispersion~Equities~Exposure~LongProfit~LongShort~MonthProfit~NetValue~Overnig~7ab97d33":"CycleOdds~CycleProfit~Dispersion~Equities~Exposure~LongProfit~LongShort~MonthProfit~NetValue~Overnig~7ab97d33","CycleOdds":"CycleOdds","CycleProfit":"CycleProfit","Dispersion":"Dispersion","Exposure":"Exposure","LongProfit":"LongProfit","LongShort":"LongShort","MonthProfit":"MonthProfit","Overnight":"Overnight","ProfitCurve":"ProfitCurve","ReturnRatio":"ReturnRatio","Sharp":"Sharp","ShortProfit":"ShortProfit","SingleVariety":"SingleVariety","TakeCycle":"TakeCycle","TopTen":"TopTen","TradeStruct":"TradeStruct","VarietyOdds":"VarietyOdds","VarietyProfit":"VarietyProfit","VarietyWeekProfit":"VarietyWeekProfit","WeekProfit":"WeekProfit","YieldDist":"YieldDist","Equities~NetValue":"Equities~NetValue","Equities":"Equities","NetValue":"NetValue","general":"general","home":"home","varietyMonthProfit":"varietyMonthProfit","DailySett":"DailySett","Report":"Report","TakeDetail":"TakeDetail","TakeTotal":"TakeTotal","TradeDetail":"TradeDetail","account":"account","analysis":"analysis","Kline":"Kline","login":"login","replay":"replay"}[chunkId]||chunkId) + "." + {"CycleOdds~CycleProfit~Dispersion~Equities~Exposure~LongProfit~LongShort~MonthProfit~NetValue~Overnig~7ab97d33":"06cdf1d4","CycleOdds":"d132d486","CycleProfit":"d9e50f9a","Dispersion":"52f38218","Exposure":"5695cf06","LongProfit":"8f6876a3","LongShort":"6a1f9dd8","MonthProfit":"31a676ef","Overnight":"2d0ec139","ProfitCurve":"20a72871","ReturnRatio":"8ed904b7","Sharp":"f1e80039","ShortProfit":"32609207","SingleVariety":"cfb14ab5","TakeCycle":"bb8d5f13","TopTen":"56b0b832","TradeStruct":"fbebd6d7","VarietyOdds":"4452fd11","VarietyProfit":"01ee1654","VarietyWeekProfit":"18be5c33","WeekProfit":"9ab56481","YieldDist":"2bf9de28","chunk-594d6d48":"8a216641","Equities~NetValue":"e042da3d","Equities":"0341344e","NetValue":"b4dcb3dc","general":"816874a9","home":"18422609","varietyMonthProfit":"0050735f","DailySett":"fc4d5820","Report":"205af630","TakeDetail":"e9cb41a2","TakeTotal":"84839587","TradeDetail":"7ee4397f","account":"18c1f71f","analysis":"da8f3640","Kline":"4cc40906","login":"c70ec824","replay":"2140c2a6","chunk-e8c341ec":"4e0306ab"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"CycleOdds":1,"CycleProfit":1,"Dispersion":1,"Exposure":1,"LongProfit":1,"LongShort":1,"MonthProfit":1,"Overnight":1,"ProfitCurve":1,"ReturnRatio":1,"Sharp":1,"ShortProfit":1,"SingleVariety":1,"TakeCycle":1,"TopTen":1,"TradeStruct":1,"VarietyOdds":1,"VarietyProfit":1,"VarietyWeekProfit":1,"WeekProfit":1,"YieldDist":1,"Equities~NetValue":1,"Equities":1,"NetValue":1,"general":1,"home":1,"varietyMonthProfit":1,"DailySett":1,"Report":1,"TakeDetail":1,"TakeTotal":1,"TradeDetail":1,"account":1,"analysis":1,"Kline":1,"login":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"CycleOdds~CycleProfit~Dispersion~Equities~Exposure~LongProfit~LongShort~MonthProfit~NetValue~Overnig~7ab97d33":"CycleOdds~CycleProfit~Dispersion~Equities~Exposure~LongProfit~LongShort~MonthProfit~NetValue~Overnig~7ab97d33","CycleOdds":"CycleOdds","CycleProfit":"CycleProfit","Dispersion":"Dispersion","Exposure":"Exposure","LongProfit":"LongProfit","LongShort":"LongShort","MonthProfit":"MonthProfit","Overnight":"Overnight","ProfitCurve":"ProfitCurve","ReturnRatio":"ReturnRatio","Sharp":"Sharp","ShortProfit":"ShortProfit","SingleVariety":"SingleVariety","TakeCycle":"TakeCycle","TopTen":"TopTen","TradeStruct":"TradeStruct","VarietyOdds":"VarietyOdds","VarietyProfit":"VarietyProfit","VarietyWeekProfit":"VarietyWeekProfit","WeekProfit":"WeekProfit","YieldDist":"YieldDist","Equities~NetValue":"Equities~NetValue","Equities":"Equities","NetValue":"NetValue","general":"general","home":"home","varietyMonthProfit":"varietyMonthProfit","DailySett":"DailySett","Report":"Report","TakeDetail":"TakeDetail","TakeTotal":"TakeTotal","TradeDetail":"TradeDetail","account":"account","analysis":"analysis","Kline":"Kline","login":"login","replay":"replay"}[chunkId]||chunkId) + "." + {"CycleOdds~CycleProfit~Dispersion~Equities~Exposure~LongProfit~LongShort~MonthProfit~NetValue~Overnig~7ab97d33":"31d6cfe0","CycleOdds":"671de46f","CycleProfit":"8ed6a44f","Dispersion":"53a22425","Exposure":"7e7e935e","LongProfit":"e258a818","LongShort":"72570138","MonthProfit":"05e5e647","Overnight":"d8b28d89","ProfitCurve":"6d61b1cf","ReturnRatio":"fa130eec","Sharp":"1686c847","ShortProfit":"41c43880","SingleVariety":"7a478c3f","TakeCycle":"5f3e9f3f","TopTen":"05e5e647","TradeStruct":"577d468d","VarietyOdds":"1e456b3c","VarietyProfit":"d8234cd3","VarietyWeekProfit":"7a478c3f","WeekProfit":"f78bfb04","YieldDist":"7bcfb1d0","chunk-594d6d48":"31d6cfe0","Equities~NetValue":"1f297d64","Equities":"0aab16af","NetValue":"0aab16af","general":"a5773daa","home":"e7b0d1da","varietyMonthProfit":"7a478c3f","DailySett":"d1411e16","Report":"9201237c","TakeDetail":"f89a4f5c","TakeTotal":"32b798d6","TradeDetail":"f89a4f5c","account":"e976fd3a","analysis":"f3e45c5e","Kline":"8c101253","login":"43cb74a0","replay":"31d6cfe0","chunk-e8c341ec":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
